import Vue from 'vue'
import Vuex from 'vuex'
import aside from './modules/aside'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    userInfo: {},
    roleId: undefined,
  },
  mutations: {
    changeUserInfo(state, info) {
      state.userInfo = JSON.parse(JSON.stringify(info))
    },
    setRoleId(state, role) {
      state.roleId = +role
    },
  },
  getters: {
    isAdmin(state) {
      return state.roleId === 1
    },
    isManager(state) {
      return state.roleId === 1 || state.roleId === 2
    },
    isCustomer(state) {
      return state.roleId === 3
    },
    isUser(state) {
      return state.roleId === 4
    },
    isBm(state) {
      return state.roleId === 5
    },
  },
  actions: {
  },
  modules: {
    aside,
  },
})
